import React from 'react';
import { useTranslation } from 'react-i18next';
import './PageTypeTag.scss';

export interface PageTypeTagProps {
  pageType: string;
}

const PAGE_TYPE_CHART_COLORS: Record<string, string> = {
  ARTICLE: '#164fce',
  HOMEPAGE: '#296551',
  PRODUCT_PAGE: '#cd823d',
  LISTICLE: '#7b4fd6',
  COMPARISON: '#3272b8',
  PROFILE: '#c24f7c',
  ALTERNATIVE: '#b8721d',
  DISCUSSION: '#2287a8',
  HOW_TO_GUIDE: '#2d8c63',
  CATEGORY_PAGE: '#8a6d4b',
  OTHER: '#686869',
};

export const getPageTypeChartColor = (pageType: string): string => {
  return PAGE_TYPE_CHART_COLORS[pageType] ?? PAGE_TYPE_CHART_COLORS.OTHER;
};

const PAGE_TYPE_CLASS_MAP: Record<string, string> = {
  ARTICLE: 'page-type-tag--article',
  HOMEPAGE: 'page-type-tag--homepage',
  PRODUCT_PAGE: 'page-type-tag--product-page',
  LISTICLE: 'page-type-tag--listicle',
  COMPARISON: 'page-type-tag--comparison',
  PROFILE: 'page-type-tag--profile',
  ALTERNATIVE: 'page-type-tag--alternative',
  DISCUSSION: 'page-type-tag--discussion',
  HOW_TO_GUIDE: 'page-type-tag--how-to-guide',
  CATEGORY_PAGE: 'page-type-tag--category-page',
  COMPETITOR: 'page-type-tag--competitor',
  OWN: 'page-type-tag--own',
  OTHER: 'page-type-tag--other',
};

const getPageTypeClass = (pageType: string): string => {
  return PAGE_TYPE_CLASS_MAP[pageType] ?? PAGE_TYPE_CLASS_MAP.OTHER;
};

export const PageTypeTag: React.FC<PageTypeTagProps> = ({ pageType }) => {
  const { t } = useTranslation();
  const labelKey = `pageType_${pageType}`;

  return (
    <span className={`page-type-tag ${getPageTypeClass(pageType)}`}>
      {t(labelKey, pageType)}
    </span>
  );
};

export default PageTypeTag;
